import React from 'react';
import { HorizontalSeperator } from '../../common/ui/styled';
import { useFeatures } from '../../services';
import { LocalDeviceCacheSection } from './local-device-cache';
import { ParallelSprintFeatureSection } from './parallel-sprints';

const PARALLEL_SPRINTS_FEATURE_KEY = 'PARALLEL_SPRINTS';
const LOCAL_DEVICE_CACHE_FEATURE_KEY = 'LOCAL_DEVICE_CACHE';

export const FeaturesSection = () => {
	const { data, updateFeature } = useFeatures();

	const isParallelSprintsFeatureVisible = PARALLEL_SPRINTS_FEATURE_KEY in data;
	const isLocalDeviceCacheFeatureVisible = LOCAL_DEVICE_CACHE_FEATURE_KEY in data;

	return (
		<>
			{isParallelSprintsFeatureVisible && (
				<ParallelSprintFeatureSection
					featureKey={PARALLEL_SPRINTS_FEATURE_KEY}
					value={data[PARALLEL_SPRINTS_FEATURE_KEY]}
					onUpdateFeature={updateFeature}
				/>
			)}
			{isLocalDeviceCacheFeatureVisible && (
				<>
					<HorizontalSeperator />
					<LocalDeviceCacheSection
						featureKey={LOCAL_DEVICE_CACHE_FEATURE_KEY}
						value={data[LOCAL_DEVICE_CACHE_FEATURE_KEY]}
						onUpdateFeature={updateFeature}
					/>
				</>
			)}
		</>
	);
};
